var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflowable-text",style:({ maxWidth: _vm.maxWidth })},[_vm._t("default"),_c('q-tooltip',[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }